/**
 * Shortens a picked place to the town it is in, for use inside sentences like
 * "≈ 40 km from {label}".
 *
 * Google returns whatever the user selected, which is often a full address
 * ("Deloitte, Raymonde De Larochelaan, Gent, Belgium"). Printing that in every distance
 * line wraps to three lines and misaligns the list, so keep the town: the last segment is
 * the country, so the one before it is the town. Labels that are already a bare town
 * ("Gent") or town + country ("Antwerpen, Belgium") are handled by the same rule.
 */
export function shortLocationLabel(query: string | null | undefined): string | null {
    if (!query) return null;
    const segments = query
        .split(',')
        .map(segment => segment.trim())
        .filter(Boolean);
    if (!segments.length) return null;
    if (segments.length === 1) return segments[0] ?? null;
    // Drop the country, keep the town; strip a leading BE ("9000") or NL ("1234 AB") postcode.
    const town = segments[segments.length - 2] ?? '';
    return town.replace(/^\d{4}\s*(?:[A-Z]{2}\s+)?/, '').trim() || town;
}
